import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash'

import { getClientInfoList } from '../../../../../../jsx/actions/devisAction';
import PreviewDevis from '../Devis/PreviewDevis';
import Image from '../../../commonModules/interface/Image';
import { TableRow, TableCell, Button, Box, Table, TableBody, Grid } from '@material-ui/core';

import { TimeLineBlock } from '../../../commonModules/interface/TimeLineMui';
import { Timeline } from '@material-ui/lab';

import { BuildRounded, LaptopMacRounded, PersonRounded,  } from '@material-ui/icons';


const ACTIONTYPE = {
    "planVisit": {icon: <BuildRounded  />, title: "Planifier une Visite"},
    "changeStatus": {icon: <PersonRounded />, title: "Changement de Statut"},
    "endVisit": {icon: <LaptopMacRounded />, title: "Rapport de Visite"},
    "addComment": {icon: <LaptopMacRounded />, title: "Nouveau Commentaire"}, 
    "addQuotation": {icon: <LaptopMacRounded />, title: "Nouveau Devis"},
    "addPdfQuotation": {icon: <LaptopMacRounded />, title: "Nouveau Devis"},
    "uploadImages": {icon: <LaptopMacRounded />, title: "Images"} 
}

class SuiviDevis extends Component {
    state = { 
        // headerMenu: "COMMENTS",
        // actions:[]
        preview: false,
        devis:{}
    }
    // componentWillMount = () => {
    //     const { ACTIONS, boxAssoId } = this.props;
        
    //         this.props.getInfos(boxAssoId)
        
        
    //     // this.getProspectComments()
    //     // this.getProspectActions()
    //     // this.getProspectQuotations()
    // }
    
    // getProspectComments = async () => {
        
    // }
    // getProspectActions = async () => {
        
    // }
    // getProspectQuotations = async () => {

    // }
    displayForm = (forms) => {
        console.log('====================================');
        console.log("DISPLAY FORMS ", {forms});
        console.log('====================================');
        try {     
            let tab = []
            forms.map( form => {
                console.log('====================================');
                console.log(form);
                console.log('====================================');
                Object.keys(form).map( key => {
                    console.log('====================================');
                    console.log({key}, form[key]);
                    console.log('====================================');
                    if (form[key].toString().startsWith("data:download")){
                        let infoD = form[key].toString().split(":");
                        tab.push(
                            <TableRow key={key}>
                                <TableCell>{key}</TableCell>
                                <TableCell><Image name={key} src={infoD[2]} image/></TableCell>
                            </TableRow>
                        )
                    } else if (form[key].toString().startsWith("data:")){
                        let infoD = form[key].toString().split(":");
                        console.log(infoD[1]);
                        tab.push(
                            <TableRow key={key}>
                                <TableCell>{key}</TableCell>
                                <TableCell><Image name={key} src={infoD[2]} mime={infoD[1]} other/></TableCell>
                            </TableRow>
                        )
                    } else {
                        tab.push(
                            <TableRow key={key}>
                                <TableCell>{key}</TableCell>
                                <TableCell>{form[key]}</TableCell>
                            </TableRow>
                        )
                    }
                })
            })  
            console.log('====================================');
            console.log({tab});
            console.log('====================================');
            return tab
        } catch (error) {
            console.log(error);
            console.log(forms);
        }
    }
    
    render() {
        const { ACTIONS, boxAssoId, RESUME, INSTALLERS } = this.props;
        console.log('=============STATE SUIVI DEVIS=================');
        console.log({ACTIONS}, this.props.ACTIONS[boxAssoId]);
        console.log('====================================');
        const translate = {
            "planVisit": "Planifier une Visite",
            "changeStatus": "Changement de Statut",
            "endVisit": "Rapport de Visite",
            "addComment": "Nouveau Commentaire",
            "addQuotation": "Nouveau Devis",
            "addPdfQuotation": "Nouveau Devis",
            "uploadImages": "Images"
        }
        const filename = {
            "changeStatus": "RAPPORT",
            "endVisit": "RAPPORT",
            "addQuotation": "DEVIS",
            "addPdfQuotation": "DEVIS",
        }
        return (
            this.state.preview ? (
                <Box p={2}>
                    <Button color="secondary" onClick={()=> window.print()}>Imprimer</Button>
                    <Box p={1}>
                        <PreviewDevis 
                            devis={this.state.devis} 
                            client={RESUME[boxAssoId]} 
                            handleClosePrev={() => this.setState({preview : false, devis:{} })} 
                        />
                    </Box>
                </Box>
            ) : (

            <div >
                {/* <Timeline  align="alternate"> */}
                <Timeline >
                    { ACTIONS[boxAssoId] && ACTIONS[boxAssoId].map(action => {
                            // PREPARE CONTENT
                        var content = <div className="pt-body">
                            {action.planVisit &&
                                <p>
                                    Visite prévu le : {new Date(action.planVisit.dateVisit).toLocaleDateString("fr-FR")} par <b>
                                        {
                                            !isEmpty(INSTALLERS) && 
                                            !isEmpty(INSTALLERS[action.planVisit.techID]) && 
                                            INSTALLERS[action.planVisit.techID].name
                                        } 
                                    </b> pour {action.planVisit.price} FCFA et {action.planVisit.nb_km} km
                                </p>
                            }
                            {typeof action.comments === "string" && 
                                <p>Commentaire: {action.comments}</p>
                            }
                            {typeof action.comments === "object" && 
                            action.comments.map(
                                (item, i) => <div className="img-responsive" style={{height: "120px"}} key={i}>
                                        <a href={"/download/document/"+item.replace("data:download:","",-1)} download={item.replace("data:download:","",-1)}>
                                            <img className="img-responsive" style={{height:"100%"}} src={"/download/document/"+item.replace("data:download:","",-1)} alt={item.replace("data:download:","",-1)}/>
                                        </a>
                                    </div>
                            )}
                            {action.quotation &&
                                <p>
                                    <Button color="primary" variant="contained" onClick={ ()=> this.setState({ devis:action.quotation, preview : true }) }>
                                        Voir le devis
                                    </Button>
                                </p>
                            }
                            {action.uploads &&
                                <p>Piece(s) Jointe(s) : 
                                    {action.uploads.name ? 
                                        <div>
                                            <Image 
                                                name={
                                                    `${filename[action.actionType]}_${RESUME[boxAssoId].Nom}-${RESUME[boxAssoId].Prénom}_${action.timeAction.split("T")[0]}`
                                                } 
                                                src={action.uploads.name} 
                                                pdf 
                                                ext={ action.uploads.name.split(".")[ action.uploads.name.split(".").length - 1] }
                                                downloadTitle={action.uploads.docName ? action.uploads.docName : "untitled"}
                                            />
                                        </div>
                                    : 
                                        action.uploads.map( (e) => (
                                            <div>
                                                <Image 
                                                    name={
                                                        `${filename[action.actionType]}_${RESUME[boxAssoId].Nom}-${RESUME[boxAssoId].Prénom}_${action.timeAction.split("T")[0]}`
                                                    } 
                                                    src={e.name} 
                                                    pdf 
                                                    ext={ e.name.split(".")[ e.name.split(".").length - 1] }
                                                    downloadTitle={e.docName}
                                                />
                                            </div>

                                        ))
                                    }
                            </p>
                            }
                            {( action.info ) &&
                                <Table className="table">
                                    <TableBody>
                                        {this.displayForm(action.info)}
                                    </TableBody>
                                </Table>
                            }
                            
                        </div>
                        let step = {
                            date: new Date(action.timeAction).toLocaleString('fr-FR') || action.timeAction,
                            icon: ACTIONTYPE[action.actionType].icon,
                            title: ACTIONTYPE[action.actionType].title,
                            content: content,
                            color:"amber"
                        }
                        return (
                            <TimeLineBlock step={step} />
                        );
                    })
                    }
                </Timeline>
            </div>
            )                
        );
    }
}

function mapStateToProps(state){
    return {
        ACTIONS: state.prospects.ACTIONS,
        RESUME: state.prospects.RESUME,
        CLIENTS: state.devis,
        INSTALLERS: state.installers,

    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getInfos: getClientInfoList,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SuiviDevis);